import { useEffect } from 'react';
import { Check, X, AlertCircle, Info } from 'lucide-react';
import './Toast.css';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const icons = {
    success: <Check size={12} strokeWidth={2.5} />,
    error: <X size={12} strokeWidth={2.5} />,
    info: <Info size={12} strokeWidth={2.5} />,
    warning: <AlertCircle size={12} strokeWidth={2.5} />,
  };

  return (
    <div className={`toast toast--${type}`}>
      <div className="toast-icon">{icons[type]}</div>
      <div className="toast-message">{message}</div>
      <button className="toast-close" onClick={onClose}>
        <X size={10} strokeWidth={2.5} />
      </button>
    </div>
  );
};

export default Toast;
